<template>
  <v-app>
    <v-main>
      <v-container>
        <status-bar v-for="(monitor, i) in monitors" :key="i" :item="monitor" :name="monitor.name" class="mb-4" />
      </v-container>
    </v-main>

    <!--
    <v-app-bar
      app
      color="primary"
      dark
    >
      <div class="d-flex align-center">
        <v-img
          alt="Vuetify Logo"
          class="shrink mr-2"
          contain
          src="https://cdn.vuetifyjs.com/images/logos/vuetify-logo-dark.png"
          transition="scale-transition"
          width="40"
        />

        <v-img
          alt="Vuetify Name"
          class="shrink mt-1 hidden-sm-and-down"
          contain
          min-width="100"
          src="https://cdn.vuetifyjs.com/images/logos/vuetify-name-dark.png"
          width="100"
        />
      </div>

      <v-spacer></v-spacer>

      <v-btn
        href="https://github.com/vuetifyjs/vuetify/releases/latest"
        target="_blank"
        text
      >
        <span class="mr-2">Latest Release</span>
        <v-icon>mdi-open-in-new</v-icon>
      </v-btn>
    </v-app-bar>

    <v-main>
      <HelloWorld/>
    </v-main>
    -->
  </v-app>
</template>

<script>
import StatusBar from "./components/StatusBar.vue";
//import HelloWorld from './components/HelloWorld';

export default {
  name: "App",

  components: {
    StatusBar,
  },

  data: () => {
    return {
      monitors: [
        { name: "vinculamos-backend", granularity: "every 10 minutes", width: "20%" },
        { name: "vinculamos-frontend", granularity: "every 10 minutes", width: "10%" },
        { name: "vinculamos-melchor", granularity: "every day at 3 AM", width: "10%" },
      ],
    };
  },

  mounted() {
  },

  methods: {
  },
};
</script>

<style scoped>
</style>